export default "__VITE_ASSET__Cu14luxA__"